import styled from 'styled-components'

export const PowerModeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const IconAnchor = styled.div`
  display: inline-flex;
  align-items: center;
`
